import { render, staticRenderFns } from "./RelateMenuModal.vue?vue&type=template&id=42d24800&scoped=true&"
import script from "./RelateMenuModal.vue?vue&type=script&lang=js&"
export * from "./RelateMenuModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d24800",
  null
  
)

export default component.exports